import { api_url } from "../configiration/config";
import { axiosClone } from './../axiosClone';

// get property types
export async function getPropertyTypes(){
  const properties=await axiosClone.get(`${api_url}/types`);
  return properties;
}
// Titles and facilities
export async function getHomeSections(){
  const titles=await axiosClone.get(`${api_url}/home`);
  return titles;
}
// get leading brands
export async function getBrands(){
  const brands=await axiosClone.get(`${api_url}/leading-brands`);
  return brands;
}
// get all cities
export async function getCities(){
  const cities=await axiosClone.get(`${api_url}/cities`);
  return cities;
}
//get areas by city
export async function getAreas(city){
  const areas=await axiosClone.get(`${api_url}/areas?city=${city}`);
  return areas;
}
//get area details by slug 
export async function getAreaDetails(slug){
  const areas=await axiosClone.get(`${api_url}/areas/${slug}`);
  return areas;
}
// get website settings
export async function getWebsiteSettings(){
  return await axiosClone.get(`${api_url}/general`);
}
// get scripts
export async function getScripts(type){
  return await axiosClone.get(`${api_url}/scripts?type=${type}`);
}
// get Languages
export async function getLanguages(){
  return await axiosClone.get(`${api_url}/languages`);
}
